import React, { useState, useContext, useEffect } from 'react'
import EquipmentService from '../../../../../services/api/equipment.service'
import { store } from '../../../../../context/StateProvider'
import EquipmentForm from '../equipment-form/EquipmentForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import ModalBox from '../../../../templates/components/ModalBox'

const AddEquipment = (props) => {
    const { inputChange } = props;
    const [formData, setFormData] = useState(props.initialData || {})
    const [messages, setMessages] = useState({})
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const [ignoreInActivePracticeServiceType, setIgnoreInActivePracticeServiceType] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [submitData, setSubmitData] = useState({})
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch

    const onSuccess = (message) => {
        dispatch({
            type: "setLocationEquipment",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }
    const onError = (error, showConfirmationModal) => {
        if (showConfirmationModal) {
            // Check if API returns array or string
            const message =
                Array.isArray(error) && error.length > 0
                    ? error[0]
                    : typeof error === "string"
                        ? error
                        : "The selected service(s) is inactive."; // fallback

            setErrorMessage(message);
            setConfirmModal(true);
        }
    }

    useEffect(() => {
        if (ignoreInActivePracticeServiceType) {
            setConfirmModal(false)
            submitHandler(submitData);
        }
    }, [ignoreInActivePracticeServiceType])

    const submitHandler = (data) => {
        setIsLoader(true)
        setSubmitData(data)
        let requestData = {
            description: data.description,
            practiceLocationId: data.practiceLocationId,
            equipmentTypeId: data.equipmentTypeId,
            practiceServiceTypeIds: data.practiceServiceTypeIds,
            practiceLocationRoomId: data.practiceLocationRoomId
        }
        if (!requestData?.practiceLocationRoomId || requestData?.practiceLocationRoomId === "") {
            delete requestData.practiceLocationRoomId
        }
        if (!requestData?.practiceServiceTypeIds || requestData?.practiceServiceTypeIds === "") {
            delete requestData.practiceServiceTypeIds
        }
        if (ignoreInActivePracticeServiceType) {
            requestData.ignoreInActivePracticeServiceType = ignoreInActivePracticeServiceType
        }
        EquipmentService.addEquipment(requestData)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIgnoreInActivePracticeServiceType(false);
                setIsLoader(false)
            });
    }

    const clearForm = () => {
        setFormData({})
    }
    return (
        <>
            {isLoader && <DimLoader />}
            <EquipmentForm submitHandler={submitHandler} initialData={formData} inputChange={inputChange} onClose={() => props.onClose()} submitLabel="Add" messages={messages} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} onError={onError} toastOnSuccess={true} />
            <ModalBox open={confirmModal} onClose={() => setConfirmModal(false)} title="Confirm">
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p>{errorMessage} Override and save equipment?</p>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                setIgnoreInActivePracticeServiceType(true);
                            }}
                        >
                            OK
                        </button>
                        <button
                            className="btn btn-secondary ms-3"
                            onClick={(e) => {
                                e.preventDefault();
                                setConfirmModal(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
        </>
    )
}

export default AddEquipment